export default {"src":"/_next/static/media/cross_64.45e1c455.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};